import axios from 'axios';

export default {
    updateTargetTimes(productTypeId, targetTimes) {
        return axios.post('/productionTimes/updateTargetTimes/', {
            productTypeId,
            targetTimes,
        });
    },
    fetchTargetTimesForProductType(productTypeId) {
        return axios.post('/productionTimes/fetchTargetTimesForProductType/', {
            productTypeId,
        });
    },
    finishProduct(id, pause) {
        return axios.post('/productionTimes/finishProduct', {
            recordId: id,
            pause,
        });
    },
    finishOptimizedPaintList(optimizedPaintlistId, knownRecordIds, pause) {
        return axios.post('/productionTimes/finishOptimizedPaintlist', {
            optimizedPaintlistId,
            knownRecordIds,
            pause,
        });
    },
    finishPleatingList(pleatingListId, knownRecordIds, pause) {
        return axios.post('/productionTimes/finishPleatingList', {
            pleatingListId,
            knownRecordIds,
            pause,
        });
    },
    finishPaintWorkOrder(paintWorkOrderId, knownRecordIds, pause) {
        return axios.post('/productionTimes/finishPaintWorkOrder', {
            paintWorkOrderId,
            knownRecordIds,
            pause,
        });
    },
    fetchProduct(productNr, workstationId, readOnly) {
        readOnly = readOnly ? true : false;
        return axios.post('/productionTimes/fetchProduct', {
            productNr,
            workstationId,
            readOnly,
        });
    },
    fetchOptimizedPaintList(optimizedPaintlistId, workstationId) {
        return axios.post('/productionTimes/fetchOptimizedPaintlist', {
            optimizedPaintlistId,
            workstationId,
        });
    },
    fetchPleatingList(pleatingListId, workstationId) {
        return axios.post('/productionTimes/fetchPleatingList', {
            pleatingListId,
            workstationId,
        });
    },
    fetchPaintWorkOrder(paintWorkOrderId, workstationId) {
        return axios.post('/productionTimes/fetchPaintWorkOrder', {
            paintWorkOrderId,
            workstationId,
        });
    },
};
